import React, { Component } from 'react';
import { Link,Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class Part8 extends Component {

    render() {

        var userToken = localStorage.getItem('token');
        if (!userToken) {
            return <Navigate to='/login' replace="true" />
        }

        return (
            <div className="docs-content">
                <div className="container">

                    {/* ========================= */}
                    {/* 1. POLICY SNAPSHOT */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            19. Policy Snapshot
                        </h1>

                        <div className="alert alert-info">
                            Hash of routing rules, PSP configuration, adapter version, and compliance rules.
                        </div>

                        <h5 className="mt-4">Purpose</h5>
                        <div className="card p-3 mt-3">
                            <ul className="mb-0 doc-page">
                                <li>Audit replay</li>
                                <li>Dispute resolution</li>
                                <li>Regulatory evidence</li>
                            </ul>
                        </div>
                    </article>


                    {/* ========================= */}
                    {/* 2. ADAPTER VERSIONING */}
                    {/* ========================= */}

                    <article className="docs-article mb-5">
                        <h1 className="docs-heading mb-4">
                            20. Adapter Versioning
                        </h1>

                        <div className="alert alert-info">
                            Explicit versioning of PSP integration logic. 
                        </div>

                        <div className="alert alert-warning mt-3">
                            Any change to mapping, retries, or auth must bump the adapter version.
                        </div>

                    </article>
                    <article class="docs-article" id="section-3">
                        <section class="docs-section row" id="item-3-1">
                            <div class="col-12">
                                <nav aria-label="Page navigation example">
                                    <ul class="pagination justify-content-between">
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-seven-doc" tabIndex="-1"
                                                aria-disabled="true"><i class="bi bi-arrow-left"></i> &nbsp;
                                                Part VII
                                            </Link>
                                        </li>
                                        <li class="page-item">
                                            <Link class="page-link" to="/part-nine-doc">
                                                Part IX &nbsp; <i class="bi bi-arrow-right"></i>
                                            </Link>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </section>
                    </article>
                </div>

                <ToastContainer closeOnClick autoClose={2000} />
            </div>
        )
    }
}